import { VerticalThreeDotIcon } from '@va/icons';
import { Button, Paragraph, paragraphSizes } from '@va/ui/design-system';
import { TooltipWrapper, useTooltipContext } from '@va/ui/tooltips';
import { ReactNode } from 'react';

export type CustomDomainAction = {
  icon: ReactNode;
  label: string;
  onClick: () => void;
};

export const CustomDomainContextMenu = ({ actions }: { actions: CustomDomainAction[] }) => {
  return (
    <TooltipWrapper
      placement='left'
      trigger='click'
      useDefaultStyle={false}
      tooltipClassNames='shadow-overlay rounded-12'
      content={
        <div className='bg-white rounded-12 p-1 w-screen max-w-[12.5rem]'>
          <ul className='space-y-1'>
            {actions.map((action, idx) => {
              return <ActionListItem key={idx} onClick={action.onClick} icon={action.icon} label={action.label} />;
            })}
          </ul>
        </div>
      }
    >
      <div>
        <Button size='small' color='quaternary' icon={() => <VerticalThreeDotIcon />} />
      </div>
    </TooltipWrapper>
  );
};

const ActionListItem = ({ icon, label, onClick }: { icon: ReactNode; label: string; onClick: () => void }) => {
  const { context } = useTooltipContext();
  return (
    <li
      onClick={() => {
        context.onOpenChange(false);
        onClick();
      }}
      className='cursor-pointer flex w-full gap-3 rounded-12 h-10 items-center px-3 hover:bg-white-snow min-w-150 transition-colors duration-300'
    >
      {icon}
      <Paragraph size={paragraphSizes.tiny}>{label}</Paragraph>
    </li>
  );
};
